export enum OENExternalCommand {
  // used to open debug panel from GoldenLayoutService
  OPEN_DEBUG_PANEL,
  // used in order to inform order entry that certain operation is launched from GoldenLayoutService
  // needed in order to kill MODIFY_INFO for  cancel and fill.
  CANCEL_LAUNCHED,
}
